import { Page } from 'model/Page';
import { Comentario } from 'model/solicitacao/comentario/Comentario';
import { CriacaoComentarioDTO } from 'model/solicitacao/comentario/CriacaoComentarioDTO';
import { Api } from '../Api';
import { ApiAxios } from '../ApiAxios';


export class ApiComentarios {
  /**
   * @param pagina Primeira página é a `1`
   */
  static async getComentarios(idSolicitacao: number, pagina: number): Promise<Page<Comentario>> {
    const paginaSpringBoot = Api.pageConvertion(pagina);

    const url = `/reinos/${Api.REINO_PADRAO}/solicitacoes/${idSolicitacao}/comentarios?page=${paginaSpringBoot}&size=20&sort=dataCriacao,desc&sort=id,desc&`;
    const response = await ApiAxios.instance.get(url);
    return response.data;
  }
  
  static async persistirNovoComentario(idSolicitacao: number, comentario: CriacaoComentarioDTO): Promise<Comentario> {
    const response = await ApiAxios.instance.post(`/reinos/${Api.REINO_PADRAO}/solicitacoes/${idSolicitacao}/comentarios`, comentario);
    return response.data;
  }
}
